// src/data/loadWeeklyWords.js
// Alle Wörter der Wochensets von Woche 1 bis `weekIndex` – eingeloggt aus Supabase
// (weekly_sets), sonst aus dem Browser-Speicher. Grundlage dafür, welche Sätze
// Lückentexte und Freie Übersetzung schon zeigen dürfen.
import { supabase } from "../supabaseClient";

const WEEKLY_KEY_PREFIX = "fluent_weeklyset_";

function getWeeklyKey(languageId, pace, totalWords, profileId, weekIndex = 1) {
  const lang = languageId || "generic";
  const p = pace || "medium";
  const t = totalWords || 0;
  const profile = profileId || "default";
  const w = weekIndex || 1;
  return `${WEEKLY_KEY_PREFIX}${profile}_${lang}_${p}_${t}_w${w}`;
}

function loadWeeklySetLocal(
  languageId,
  pace,
  totalWords,
  profileId,
  weekIndex = 1
) {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(
      getWeeklyKey(languageId, pace, totalWords, profileId, weekIndex)
    );
    if (!raw) return [];
    const data = JSON.parse(raw);
    if (Array.isArray(data) && data.length > 0) return data;
    return [];
  } catch (e) {
    console.warn("loadWeeklyWords: weekly set load error (local):", e);
    return [];
  }
}

/**
 * Wochensets von Woche 1 bis `weekIndex`, getrennt nach Woche: { [woche]: words }.
 * Eingeloggt aus Supabase (weekly_sets), sonst aus dem Browser-Speicher.
 */
export async function loadWeeklySetsByWeek({
  langId,
  pace,
  weeklyWords,
  profile,
  weekIndex,
}) {
  const byWeek = {};

  let userId = null;
  try {
    const { data: userData } = await supabase.auth.getUser();
    userId = userData?.user?.id || null;
  } catch (e) {
    console.warn("loadWeeklyWords: getUser failed:", e);
  }

  if (userId) {
    try {
      const { data, error } = await supabase
        .from("weekly_sets")
        .select("week_index, words")
        .eq("user_id", userId)
        .eq("profile_id", profile)
        .eq("language_id", langId)
        .eq("pace", pace)
        .eq("total_words", weeklyWords)
        .lte("week_index", weekIndex);

      if (error) {
        console.warn("loadWeeklyWords: remote weekly_sets load error:", error);
      } else if (Array.isArray(data)) {
        data.forEach((row) => {
          if (Array.isArray(row.words)) {
            byWeek[row.week_index] = row.words;
          }
        });
      }
    } catch (e) {
      console.warn("loadWeeklyWords: remote weekly_sets exception:", e);
    }
  } else {
    for (let w = 1; w <= weekIndex; w++) {
      const weekly = loadWeeklySetLocal(langId, pace, weeklyWords, profile, w);
      if (Array.isArray(weekly) && weekly.length > 0) {
        byWeek[w] = weekly;
      }
    }
  }

  return byWeek;
}

/** Alle Wörter der Wochensets von Woche 1 bis `weekIndex` in einer Liste */
export async function loadWeeklyWordsUpToWeek(options) {
  const byWeek = await loadWeeklySetsByWeek(options);
  return Object.keys(byWeek)
    .sort((a, b) => a - b)
    .flatMap((w) => byWeek[w]);
}
